.pickerBar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.seg {
  display: inline-flex;
  gap: 2px;
  padding: 3px;
  border-radius: 999px;
  background: var(--pill-bg);
  box-shadow: inset 0 0 0 1px var(--line);
}

.seg button {
  padding: 5px 13px;
  font-size: 13px;
  background: transparent;
  color: var(--muted);
}

.seg button[aria-pressed='true'] {
  background: var(--fill);
  color: var(--on-fill);
}

.search {
  flex: 1 1 200px;
  min-width: 0;
}

.pickerBody {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 220px;
  gap: 18px;
  align-items: start;
}

.tiles {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(78px, 1fr));
  gap: 10px;
  max-height: 52vh;
  overflow-y: auto;
  padding: 4px;
}

.tile {
  display: grid;
  gap: 5px;
  padding: 0;
  min-width: 0;
  background: transparent;
  color: var(--text);
  font-weight: 400;
}

.tileImg {
  position: relative;
  display: grid;
  place-items: center;
  aspect-ratio: 180 / 314;
  border-radius: 10px;
  border: 1px solid var(--line);
  overflow: hidden;
  font-family: var(--font-display, inherit);
  font-size: 20px;
  color: var(--muted);
  background: var(--pill-bg);
}

.tileImg img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.tile[aria-selected='true'] .tileImg {
  border-color: var(--accent);
  box-shadow: 0 0 0 2px var(--accent);
}

.tileName {
  font-size: 12px;
  line-height: 1.3;
  color: var(--muted);
  text-align: center;
  overflow-wrap: anywhere;
}

.own {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 1px 6px;
  border-radius: 999px;
  background: var(--fill);
  color: var(--on-fill);
  font-family: var(--font-body, inherit);
  font-size: 9px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.preview {
  position: sticky;
  top: 0;
  display: grid;
  justify-items: center;
  gap: 8px;
  text-align: center;
}

.previewHead {
  font-weight: 500;
  font-size: 14px;
}

.previewBody {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: var(--muted);
  display: -webkit-box;
  -webkit-line-clamp: 8;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.hint {
  margin: 0;
  font-size: 13px;
  color: var(--muted);
}

.banner {
  display: grid;
  gap: 2px;
  padding: 12px 14px;
  margin-bottom: 14px;
  border-radius: 14px;
  font-size: 14px;
  background: color-mix(in srgb, var(--accent) 10%, transparent);
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--accent) 45%, transparent);
}

.banner[data-tone='bad'] {
  background: color-mix(in srgb, var(--danger) 10%, transparent);
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--danger) 45%, transparent);
}

.previewWrap {
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
}

@media (max-width: 720px) {
  .pickerBody {
    grid-template-columns: minmax(0, 1fr);
  }

  .preview {
    position: static;
    order: -1;
    gap: 4px;
  }

  .preview > :first-child {
    display: none;
  }

  .previewBody {
    -webkit-line-clamp: 3;
  }

  .tiles {
    max-height: 40vh;
  }
}

.tile:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}
